import { ChangeDetectionStrategy, Component, HostBinding } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { views } from "../../../../../app/phone/views";
import { AdminE911AddLocationModalComponent } from "../../addLocationModal/add-location-modal.component";

@Component({
  selector: "onsip-admin-e911-empty-state-no-location",
  templateUrl: "./e911-no-location.component.html",
  styleUrls: ["./e911-no-location.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminE911NoLocationComponent {
  @HostBinding("class.onsip-grid-content")
  @HostBinding("class.onsip-admin-host-grid")
  _dontUse = true;

  views = views;

  constructor(private dialog: MatDialog) {}

  openAddLocationModal(): void {
    this.dialog.open(AdminE911AddLocationModalComponent, {
      panelClass: ["mat-typography", "onsip-dialog-universal-style"],
      disableClose: true
    });
  }
}
